import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../containers/RegisterPage'

const Register = () => (
    <React.Fragment>
        <Page />
    </React.Fragment>
)

Register.propTypes = {
    children: PropTypes.node
}

export default Register